import { config } from '../utils/config';
import { safeStorage } from '../utils/storageHelper';

const ADMIN_BASE = `${config.API_BASE_URL}${config.API_PREFIX}/api/v1/admin`;

const getHeaders = () => {
  const token = safeStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const buildQuery = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  return q.toString();
};

const fetchLog = async (endpoint, params = {}) => {
  const qs = buildQuery(params);
  const url = `${ADMIN_BASE}/logs/${endpoint}/${qs ? `?${qs}` : ''}`;
  const res = await fetch(url, { headers: getHeaders() });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json();
};

const exportLog = (endpoint, params = {}) => {
  // Use direct window navigation — avoids CORS preflight and Content-Disposition issues
  const q = buildQuery(params);
  const url = `${ADMIN_BASE}/logs/${endpoint}/export/?${q}`;
  // Create hidden link and click — browser handles the file download natively
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const LogService = {
  authentication : (p) => fetchLog('authentication', p),
  userActivity   : (p) => fetchLog('user-activity', p),
  orders         : (p) => fetchLog('orders', p),
  payments       : (p) => fetchLog('payments', p),
  api            : (p) => fetchLog('api', p),
  errors         : (p) => fetchLog('errors', p),
  adminActivity  : (p) => fetchLog('admin-activity', p),
  inventory      : (p) => fetchLog('inventory', p),
  notifications  : (p) => fetchLog('notifications', p),
  shipments      : (p) => fetchLog('shipments', p),
  visitPages     : (p) => fetchLog('visit-pages', p),
  orderStatus    : (p) => fetchLog('order-status', p),

  exportAuthentication : (p) => exportLog('authentication', p),
  exportUserActivity   : (p) => exportLog('user-activity', p),
  exportOrders         : (p) => exportLog('orders', p),
  exportPayments       : (p) => exportLog('payments', p),
  exportApi            : (p) => exportLog('api', p),
  exportErrors         : (p) => exportLog('errors', p),
  exportAdminActivity  : (p) => exportLog('admin-activity', p),
  exportInventory      : (p) => exportLog('inventory', p),
  exportNotifications  : (p) => exportLog('notifications', p),
  exportShipments      : (p) => exportLog('shipments', p),
  exportVisitPages     : (p) => exportLog('visit-pages', p),
  exportOrderStatus    : (p) => exportLog('order-status', p),
  rboActivity          : (p) => fetchLog('rbo-activity', p),
  exportRboActivity    : (p) => exportLog('rbo-activity', p),
};
